<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-toolbar
					dark
					flat
					prominent
					class="py-4"
					:src="outlet.image_url"
				>
					<v-layout
						row
						wrap
						class="text-center"
						style="
							background-color: rgb(25 117 209 / 70%);
							height: 100%;
						"
					>
						<v-flex xs12>
							<h3>{{ outlet.name }}</h3>
							<p>{{ outlet.phone }}</p>
							<p>{{ outlet.address }}</p>
						</v-flex>
					</v-layout>

					<template v-slot:extension> </template>
				</v-toolbar>
			</v-card-title>
			<v-card-subtitle
				v-html="outlet.description"
				class="pt-10"
			></v-card-subtitle>
			<v-card-title primary-title>
				<v-layout row wrap>
					<v-flex xs12 md6>
						<v-list>
							<Link
								as="v-list-item"
								:href="
									$route('reservation.create', {
										tenant: outlet.tenant_id,
										outlet: outlet.uuid,
									})
								"
							>
								<v-list-item-action>
									<v-icon>mdi-calendar</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{
										$t("title.make_a_reservation")
									}}</v-list-item-title>
									<v-list-item-subtitle>
										Reserve your table in advanced!
									</v-list-item-subtitle>
								</v-list-item-content>
							</Link>
							<v-divider></v-divider>
							<Link
								as="v-list-item"
								:href="
									$route('shop.pickup.products', {
										tenant: outlet.tenant_id,
										outlet: outlet.uuid,
									})
								"
							>
								<v-list-item-action>
									<v-icon>mdi-cart</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{
										$t("title.place_an_order")
									}}</v-list-item-title>
									<v-list-item-subtitle>
										{{ $t("label.delivery") }},
										{{ $t("label.pickup") }},
										{{ $t("label.dine_in") }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</Link>
						</v-list>
					</v-flex>
					<v-flex xs12 md6>
						<GmapMap
							:center="{ lat: latitude, lng: longitude }"
							:zoom="15"
							map-type-id="terrain"
							style="width: 100%; height: 400px"
							ref="mapRef"
						>
							<GmapMarker
								:position="{ lat: latitude, lng: longitude }"
								:clickable="false"
								:draggable="false"
								@click="
									center = { lat: latitude, lng: longitude }
								"
							/>
						</GmapMap>
					</v-flex>
				</v-layout>
			</v-card-title>
		</v-card>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["outlet"],
	computed: {
		latitude() {
			return this.outlet.latitude ? this.outlet.latitude : 11.5564;
		},
		longitude() {
			return this.outlet.longitude ? this.outlet.longitude : 104.9282;
		},
	},
};
</script>